import { useState, useEffect, useCallback } from 'react';
import Axios from 'axios';

const POLL_MS = 30_000;

export const useInbox = () => {
  const [messages,    setMessages]    = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);

  const fetch = useCallback(async () => {
    try {
      const { data } = await Axios.get('/api/notifications/inbox?limit=20');
      const inner = data?.data;
      setMessages(inner?.data    ?? []);
      setUnreadCount(inner?.unreadCount ?? 0);
    } catch (_) {}
  }, []);

  const markOne = useCallback(async (id) => {
    try {
      await Axios.patch(`/api/notifications/inbox/${id}/read`);
      setMessages(prev => prev.map(m => m.id === id ? { ...m, isRead: true } : m));
      setUnreadCount(prev => Math.max(0, prev - 1));
    } catch (_) {}
  }, []);

  const markAll = useCallback(async () => {
    try {
      await Axios.patch('/api/notifications/inbox/read-all');
      setMessages(prev => prev.map(m => ({ ...m, isRead: true })));
      setUnreadCount(0);
    } catch (_) {}
  }, []);

  useEffect(() => {
    fetch();
    const id = setInterval(fetch, POLL_MS);
    return () => clearInterval(id);
  }, [fetch]);

  return { messages, unreadCount, markOne, markAll };
};
